module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Sketch-30576b07b1465c4fab797036d2ae55da5d0c4f04d7079c586a94bb59474ae7f1.svg";